/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconGoogle = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <path
        fill="currentColor"
        d="M6.1 7.4a.5.5 0 0 0 .68-.06 7 7 0 0 1 10.32-.13.5.5 0 0 0 .707.003l.003-.003 2.92-2.74a.5.5 0 0 0 .003-.707l-.003-.003C16.186-1.064 8.591-1.291 3.767 3.253c-.305.287-.594.59-.867.907a.5.5 0 0 0 .1.74l3.1 2.5zm-.86 7.39a.5.5 0 0 0 .14-.53 6.896 6.896 0 0 1 0-4.46.501.501 0 0 0-.16-.55L1.95 6.64a.5.5 0 0 0-.76.17 11.931 11.931 0 0 0 .15 10.65.5.5 0 0 0 .78.14l3.12-2.81zM24 10.5a.5.5 0 0 0-.5-.5h-10a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h4.84a6.824 6.824 0 0 1-1.14 1.67.5.5 0 0 0 0 .67l2.67 3a.5.5 0 0 0 .73 0A11.998 11.998 0 0 0 24 12.6v-2.1zm-8.48 7.96a.5.5 0 0 0-.58-.12 6.93 6.93 0 0 1-8.1-1.63.5.5 0 0 0-.7 0l-3 2.68a.5.5 0 0 0-.003.707l.003.003a12 12 0 0 0 15 2.25.5.5 0 0 0 .12-.76l-2.74-3.13z"
      />
    </svg>
  ),
);
